'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderLineItem(name, unitPrice, quantity, quantityUnit, grossWeight, netWeight, referenceNumber) {
  this.aFn = null;
  this.FB = null;
  this.BH = null;
  this.LS = null;
  this.LT = null;
  this.tj = null;
  this.tk = null;
  this.BG = null;
  this.FB = name;
  this.BH = unitPrice;
  this.LS = quantity;
  this.LT = quantityUnit;
  this.tj = grossWeight;
  this.tk = netWeight;
  this.BG = referenceNumber;
  var this$2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Extract$();
  this.aFn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Extract$$anon$1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_package$().FX, this$2);
}
export { $c_Lapp_data_PurchaseOrderLineItem as $c_Lapp_data_PurchaseOrderLineItem };
$p = $c_Lapp_data_PurchaseOrderLineItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderLineItem;
/** @constructor */
function $h_Lapp_data_PurchaseOrderLineItem() {
}
export { $h_Lapp_data_PurchaseOrderLineItem as $h_Lapp_data_PurchaseOrderLineItem };
$h_Lapp_data_PurchaseOrderLineItem.prototype = $p;
$p.IB = (function() {
  return this.aFn;
});
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_PurchaseOrderLineItem)) {
    if ((this.FB === x$0.FB)) {
      var x = this.BH;
      var x$2 = x$0.BH;
      var $x_4 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$3 = this.LS;
      var x$4 = x$0.LS;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.LT === x$0.LT))) {
      var x$5 = this.tj;
      var x$6 = x$0.tj;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.tk;
      var x$8 = x$0.tk;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.BG;
      var x$10 = x$0.BG;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 7;
});
$p.t = (function() {
  return "PurchaseOrderLineItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.FB;
      break;
    }
    case 1: {
      return this.BH;
      break;
    }
    case 2: {
      return this.LS;
      break;
    }
    case 3: {
      return this.LT;
      break;
    }
    case 4: {
      return this.tj;
      break;
    }
    case 5: {
      return this.tk;
      break;
    }
    case 6: {
      return this.BG;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "unitPrice";
      break;
    }
    case 2: {
      return "quantity";
      break;
    }
    case 3: {
      return "quantityUnit";
      break;
    }
    case 4: {
      return "grossWeight";
      break;
    }
    case 5: {
      return "netWeight";
      break;
    }
    case 6: {
      return "referenceNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Kb = (function() {
  return this.BH;
});
$p.Es = (function() {
  return this.LS;
});
$p.agr = (function() {
  return this.LT;
});
$p.a5q = (function() {
  return this.tj;
});
$p.a5O = (function() {
  return this.tk;
});
function $isArrayOf_Lapp_data_PurchaseOrderLineItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jR)));
}
export { $isArrayOf_Lapp_data_PurchaseOrderLineItem as $isArrayOf_Lapp_data_PurchaseOrderLineItem };
var $d_Lapp_data_PurchaseOrderLineItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderLineItem, "app.data.PurchaseOrderLineItem", ({
  jR: 1,
  eC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_PurchaseOrderLineItem as $d_Lapp_data_PurchaseOrderLineItem };
//# sourceMappingURL=app.data.-Purchase-Order-Line-Item.js.map
